import { useState } from 'react'

//props
interface GalleryItemProps {
    item: Song,
    key: number
}

// item
interface Song {
    trackName: string
    collectionName: string
    artworkUrl100: string
    primaryGenreName: string
    releaseDate: string
}

function GalleryItem(props: GalleryItemProps){
    let [view, setView] = useState(false)

    const simpleView = () => {
        return (
            <div style={{
                'width': '25vw',
                'height': '20vh',
                'border': '1px solid black',
                'margin' : '2px',
                'position': 'relative'
            }}>
                <h3>{props.item.trackName}</h3>
                <h4>{props.item.collectionName}</h4>
            </div>
            // {
            //     trackName: string,
            //     collectionName: string
            // }
        )
    }

    const detailView = () => {
        return (
            <div style={{
                'width': '80vw',
                'height': '20vh',
                'border': '1px solid black',
                'margin' : '2px',
                'position': 'relative',
                'backgroundImage': `url(${props.item.artworkUrl100})`,
                'backgroundRepeat': 'no-repeat',
                'backgroundSize': 'cover',
                'color': 'white'
            }}>
                <h2>{props.item.trackName}</h2>
                <h3>{props.item.collectionName}</h3>
                <h4>{props.item.primaryGenreName}</h4>
                <h4>{props.item.releaseDate}</h4>
            </div>
            // item {
            //      trackName: string,
            //      collectionName: string,
            //      artworkUrl100: string,
            //      primaryGenreName: string,
            //      releaseDate: string
            // }
        )
    }

    return (
        <div onClick={() => setView(!view)}
        style={{'display': 'inline-block'}}>
            {view ? detailView() : simpleView()}
        </div>
    )
} 

export type {Song}
export default GalleryItem
